import Vue from "vue";
import Vuex from "vuex";
import userStore from "./user";
import configurationStore from "./configuration";
import projectStore from "./projects";
import applicationStore from "./application";

Vue.use(Vuex);

const store = new Vuex.Store({
    modules: {
        application: applicationStore,
        user: userStore,
        configuration: configurationStore,
        projects: projectStore
    },
    actions: {
        initStore(context) {
            context.dispatch("application/initStore");
            context.dispatch("configuration/initStore");
            context.dispatch("projects/initStore");
        }
    }
});

export default store;
